import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import { api } from "@/lib/api";
import { ReportStatus } from "@/lib/reports";
import { Panel } from "@/components/common/ui-kit";

export const MonthEndBanner = ({ reloadKey }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/service-reports/month-end").then((r) => setD(r.data)).catch(() => setD(null)); }, [reloadKey]);
  if (!d?.items.length) return null;
  const late = d.items.filter((r) => r.overdue).length;
  return (
    <Panel className="mb-4 border-amber-300 bg-amber-50/60 p-4" data-testid="month-end-banner">
      <div className="flex items-start gap-3">
        <CalendarClock className="mt-0.5 h-5 w-5 shrink-0 text-amber-700" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-ink" data-testid="month-end-title">
            {d.items.length} rapportin{d.items.length === 1 ? "o" : "i"} mensil{d.items.length === 1 ? "e" : "i"} da chiudere per la fatturazione
            {late > 0 && <span className="text-red-700"> · {late} di mesi già terminati</span>}
          </p>
          <p className="text-xs text-slate-600">{d.window ? `Mese ${d.period}: ${d.days_left === 0 ? "ultimo giorno" : `mancano ${d.days_left} giorni`} alla chiusura.` : "Mesi precedenti ancora aperti."} Conferma il rapportino per chiudere il mese; le ore successive andranno nel rapportino del mese dopo.</p>
          <ul className="mt-2 divide-y divide-amber-200/70">
            {d.items.map((r) => (
              <li key={r.id} className="flex flex-wrap items-center gap-2 py-1.5 text-sm" data-testid={`month-end-item-${r.id}`}>
                <Link to={`/rapportini/${r.id}`} className="font-mono text-xs font-semibold text-brand-700 hover:underline">{r.number}</Link>
                <span className="font-medium text-ink">{r.company_name}</span>
                <span className="text-xs text-slate-500">{r.intervention?.number} · {r.intervention?.title}</span>
                <span className={`ml-auto text-xs font-semibold ${r.overdue ? "text-red-700" : "text-amber-700"}`}>Mese {r.period}</span>
                <ReportStatus status={r.status} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Panel>
  );
};
